/*
----- Footer ----- 
- This is the functionality for express's footer.
- Footer menu
  - Revealing
  - Submenu detection.
*/

// ---- Initialise footer menu ----
// Footer menu selector.
let footerMenu = $(expressSelectors()['footer']['menu']);
// If footer menu exists.
if (footerMenu.length > 0) {
    // Check wether list has sub-menu's
    let submenus = footerMenu.find('li > ul');
    // Add classes.
    submenus.addClass('submenu');
    submenus.parent('li').addClass('submenu-parent');
    // Find parents.
    let parents = footerMenu.find('.submenu-parent');
    // Add click listener for parents.
    parents.on('click', function() {
        // Grab context.
        let parent = $(this);
        // Toggle classes.
        parent.toggleClass('active');
        parent.find('> ul').toggleClass('active');
    });
}